import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ICreateException } from '../../../models';
import { GetExceptionState } from '../../actions/types/exceptions/GetExceptionTypes';

/**
 * Initial Dashboard state in store
 */
export const initialState: GetExceptionState = {
  isLoading: false,
  success: false,
  isError: false,
  errorMessage: '',
  GetExceptions: [],
};

/**
 * get metric summary Slice to get metric
 */
export const getExceptionSlice = createSlice({
  name: 'getMetricsSummary',
  initialState,
  reducers: {
    getExceptionStarted: (state) => {
      state.isLoading = true;
    },
    getExceptionSuccess: (state, action: PayloadAction<ICreateException[]>) => {
      state.isLoading = false;
      state.success = true;
      state.isError = false;
      state.errorMessage = '';
      state.GetExceptions = action.payload;
    },

    getExceptionFail: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.success = false;
      state.isError = true;
      state.errorMessage = action.payload;
      state.GetExceptions = initialState.GetExceptions;
    },

    clearGetException: (state) => {
      state.isLoading = false;
      state.success = false;
      state.isError = false;
      state.errorMessage = '';
      state.GetExceptions = initialState.GetExceptions;
    },
  },
});

export const {
  getExceptionStarted,
  getExceptionSuccess,
  getExceptionFail,
  clearGetException,
} = getExceptionSlice.actions;
export default getExceptionSlice.reducer;
